import config from './config';
import configOverride from './config.override';

export default { ...config, ...configOverride };
